export const SHOP_CATEGORIES = [
  "مطاعم", "بقالة", "حلويات", "خضار وفواكه", "لحوم ودواجن",
  "مخابز", "صيدلية", "إلكترونيات", "ملابس", "عام",
];

export const CATEGORY_FILTERS = ["الكل", ...SHOP_CATEGORIES, "مختارات اليوم"];

export const ORDER_STATUS = {
  pending: { label: "بانتظار الموافقة", color: "status-pending" },
  accepted: { label: "تم القبول", color: "status-accepted" },
  preparing: { label: "قيد التحضير", color: "status-preparing" },
  ready: { label: "جاهز للتوصيل", color: "status-ready" },
  out_for_delivery: { label: "في الطريق إليك", color: "status-delivery" },
  delivered: { label: "تم التوصيل", color: "status-delivered" },
  cancelled: { label: "ملغي", color: "status-cancelled" },
};

export const ROLE_LABELS = { buyer: "مشتري", seller: "بائع / متجر", driver: "سائق توصيل" };
